export function checkPassword(password: string) {
    return password.length >= 8;
}